import { createSlice } from "@reduxjs/toolkit";
import { postCustomFieldtoPatients } from "../API/Patients";

const initialState = {
    customFieldData: [],
    loading: false,
    error: null,
};

const CustomFieldSlice = createSlice({
  name: "CustomField",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postCustomFieldtoPatients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postCustomFieldtoPatients.fulfilled, (state, action) => {
        state.loading = false;
        state.customFieldData = action.payload;
      })
      .addCase(postCustomFieldtoPatients.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
      })
  },
});

export default CustomFieldSlice.reducer;